export default __webpack_public_path__ + "static/media/2206.16aaef90.png";